import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';
import urijs from 'urijs';

const ccBaseUrl = config.get('CCBaseUrl');

/**
 * Get absolulte client center URL. Do not include 'cc/' in path.
 * Examples:
 * getCCUrl(['accounts','list']) => https://<root url>/cc/accounts/list
 * getCCUrl('accounts/list') => https://<root url>/cc/accounts/list
 * @param {string | Array} path Relative path or an array of path segments, should not include 'cc/' in this path
 * @param {JSON} queryParams Params in URL
 * @returns {string} String of URL
 */
export const getCCUrl = (path, queryParams = null) => {
  const ccBaseUri = urijs(ccBaseUrl);
  const additionalSegment = _.isArray(path) ? path : [path];
  const ccUri = ccBaseUri.segment([...ccBaseUri.segment(), ...additionalSegment]);

  if (queryParams) {
    ccUri.setQuery(queryParams);
  }
  return ccUri.toString();
};
